<template>
  <div class="page-container-wrapper">
    <transition :name="transitionName">
      <keep-alive :include="cacheRoutes">
        <router-view :key="$route.fullPath" class="views"></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { analyticFun } from "@/api/finger";
import { urlLinkAg } from "@/utils/request";
export default {
  name: "App",
  data() {
    return {
      isMobile: true,
      cacheRoutes: [
        "knowledge",
        "shareFromRokiApp",
        "lineViewsFromRokiApp",
        "newKitchenDay",
        "cookCulture",
        "rewardInfo",
        "answerHome",
        "answerQuestionOne",
        "questionSubmitName",
        "questionResult",
        "questionPoster",
        "lotteryForQuestion",
        "dunHuangHome",
        "juneLottery",
        "jiashizao",
        "freeTrial",
        "deliciousArea",
        "dunHuangRecipes",
        "welcome",
        "dunHuangGame",
        "dunHuangSuccess",
        "themeList",
        "themeDetail",
        // "blindThemeDetail",
        "albumsPicture",
        "flagHome",
        "chooseFlag",
        "chooseFlagTwo",
        "chooseFlagThree",
        "chooseFlagFour",
        "signature",
        "myFlagLists",
        "helpFriendsVerifyFlag",
        "cookingChallengeHome",
        "selectOptions",
        "aiSignature",
        "aiGenerateRecipe",
        "aiLottery",
        "shareAiRecipe",
        "familyBanner",
        "threeStoveActHome",
        "shareStoveAct",
        "threeStoveAnswerQuestion",
        "threeStoveAnswerResult",
        "stoveActLottery",
        "threeStoveProductDetail",
        "userExperience",
        "userExperienceNew",
        "favoriteRecipeHome",
        "favoriteRecipeSelections",
        "favoriteRecipeChoosed",
        "favoriteRecipeMyWorks",
        "favoriteRecipeTopsRank",
        "favoriteRecipeDetail",
        "favoriteRecipeUpload",
        "favoriteRecipeUploadSuccess",
        "favoriteRecipeShare",
        "favoriteRecipeHomeZongyi",
        "favoriteRecipeSelectionsZongyi",
        "favoriteRecipeChoosedZongyi",
        "favoriteRecipeMyWorksZongyi",
        "favoriteRecipeTopsRankZongyi",
        "favoriteRecipeDetailZongyi",
        "favoriteRecipeUploadZongyi",
        "favoriteRecipeUploadSuccessZongyi",
        "favoriteRecipeShareZongyi",
        "cookingChallengeHomeOfPeriodTwo",
        "selectOptionsOfPeriodTwo",
        "aiSignatureOfPeriodTwo",
        "aiGenerateRecipeOfPeriodTwo",
        "aiLotteryOfPeriodTwo",
        "shareAiRecipeOfPeriodTwo",
        "openBlindBoxHome", //findFavoriteRecipeFestival
        "favoriteRecipeHomeFestival",
        "favoriteRecipePeriodsShowFestival",
        "favoriteRecipeSelectionsFestival",
        "favoriteRecipeChoosedFestival",
        "favoriteRecipeMyWorksFestival",
        "favoriteRecipeTopsRankFestival",
        "favoriteRecipeDetailFestival",
        "favoriteRecipeUploadFestival",
        "favoriteRecipeUploadSuccessFestival",
        "favoriteRecipeShareFestival",
        "FestivalWorksVerify"
      ],
      //transitionName: "slide-right" //初始过度动画方向
      transitionName: "" //初始过度动画方向
    };
  },
  watch: {
    $route(to, from) {
      //console.log('this.$route',this.$router);
      let isBack = this.$router.isBack;
      if (isBack) {
        // this.transitionName = "slide-right";
      } else {
        // this.transitionName = "slide-left";
      }
      this.$router.isBack = false;
    }
  },
  mounted() {
    console.log("this.$route---", this.$route, "window---", location.hash);
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OpenHarmony|Opera Mini/i.test(
      navigator.userAgent
    );
    //this.isMobile = isMobile;
    this.generateFingerprint();
    this.playBgAudio();
  },
  methods: {
    playBgAudio() {
      const arr = [
        { pathName: "flagHome", label: "changeNewFlag" },
        { pathName: "chooseFlag", label: "chooseFlag" },
        { pathName: "chooseFlagTwo", label: "chooseFlagTwo" },
        { pathName: "chooseFlagThree", label: "chooseFlagThree" },
        { pathName: "chooseFlagFour", label: "chooseFlagFour" },
        { pathName: "signature", label: "signature" },
        { pathName: "myFlagLists", label: "myFlagLists" },
        { pathName: "helpFriendsVerifyFlag", label: "changeNewFlag" }
      ];
      const currentPath = location.hash;
      var activityName = undefined;
      arr.forEach(item => {
        if (currentPath.indexOf(item.pathName) > -1) {
          activityName = item.label;
        }
      });
      if (activityName) {
        const current = process.env.NODE_ENV;
        const audioUrl =
          current == "development" || current == "testing"
            ? "http://develop.h5.myroki.com/wxshareImg/flagbgAudio.mp3"
            : "https://h5.myroki.com/wxshareImg/flagbgAudio.mp3";
        let audio = document.createElement("audio");
        audio.setAttribute("src", audioUrl);
        audio.setAttribute("loop", true);
        if (window.WeixinJSBridge) {
          WeixinJSBridge.invoke(
            "getNetworkType",
            {},
            function(e) {
              audio.play();
            },
            false
          );
        } else {
          document.addEventListener(
            "WeixinJSBridgeReady",
            function() {
              WeixinJSBridge.invoke("getNetworkType", {}, function(e) {
                audio.play();
              });
            },
            false
          );
        }
        //audio.load();
        audio.play();
      }
    },
    async generateFingerprint() {
      const lists = [
        { pathName: "dunHuangHome", label: "dunhuang" },
        { pathName: "answerHome", label: "ZJ_H5_GAME" },
        { pathName: "flagHome", label: "changeNewFlag" },
        { pathName: "helpFriendsVerifyFlag", label: "changeNewFlag" },
        { pathName: "cookingChallengeHome", label: "lazyKitchen" },
        { pathName: "shareAiRecipe", label: "lazyKitchen" },
        { pathName: "threeStoveActHome", label: "FullScoreBreeder" },
        { pathName: "shareStoveAct", label: "FullScoreBreeder" },
        { pathName: "userExperience", label: "questionnaire" },
        { pathName: "userExperienceNew", label: "questionnaire2" },
        { pathName: "favoriteRecipeHome", label: "collectFavor" },
        { pathName: "favoriteRecipeShare", label: "collectFavor" },
        { pathName: "favoriteRecipeTopsRank", label: "collectFavor" },
        { pathName: "favoriteRecipeHomeZongyi", label: "RokiFoodChallenge" },
        { pathName: "favoriteRecipeShareZongyi", label: "RokiFoodChallenge" },
        {
          pathName: "favoriteRecipeTopsRankZongyi",
          label: "RokiFoodChallenge"
        },
        { pathName: "cookingChallengeHomeOfPeriodTwo", label: "AICOOKING" },
        { pathName: "openBlindBoxHome", label: "NewYearBlindBox" },
        { pathName: "scienceFestival", label: "UserCommunication" },
        {
          pathName: "favoriteRecipeHomeFestival",
          label: "collectFavorFestival"
        },
        {
          pathName: "favoriteRecipeShareFestival",
          label: "collectFavorFestival"
        },
        {
          pathName: "favoriteRecipeTopsRankFestival",
          label: "collectFavorFestival"
        }
      ];
      const currentPath = location.hash;
      var activityName = undefined;
      lists.forEach(item => {
        if (currentPath.indexOf(item.pathName) > -1) {
          activityName = item.label;
        }
      });
      console.log("activityName", activityName);
      const options = {
        excludes: { enumerateDevices: false }
      };
      const fp = await FingerprintJS.load(options);
      const result = await fp.get();
      const visitorId = result.visitorId;
      console.log("visitorId", visitorId);
      const userInfo = JSON.parse(localStorage.getItem("userInfokey"));
      const { terminal, userId: appUserId } = this.$route.query;
      let userId = "";
      if (terminal == "app") {
        userId = appUserId || "";
      } else {
        userId = userInfo && userInfo.id ? userInfo.id : "";
      }
      analyticFun({ userId, fingerId: visitorId, activityName }).then(res => {
        console.log("标识结果：----", res);
      });
    }
  }
};
</script>

<style lang="scss">
.page-container-wrapper {
  &.is-pc {
    max-width: 65vw;
    margin: 0 auto;
  }
}
:root {
  --safe-area-inset-bottom: 0px; //微信浏览器中获取安全距离始终为0；
}
@supports (top: env(safe-area-inset-top)) {
  :root {
    --safe-area-inset-bottom: constant(safe-area-inset-bottom);
  }
}
@supports (top: env(safe-area-inset-top)) {
  :root {
    --safe-area-inset-bottom: env(safe-area-inset-bottom);
  }
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  //   background: #f5f5f8;
}
// .views {
//   position: absolute;
//   width: 100%;
//   transition: all 0.8s ease;
//   top: 0;
// }
// .slide-left-enter-active {
//   transition: all 0.3s ease;
// }
// .slide-left-leave-active {
//   transition: all 0.8s ease;
// }
// .slide-left-enter {
//   transform: translateX(100%);
//   opacity: 0;
// }
// .slide-left-leave-to {
//   transform: translateX(-100%);
//   opacity: 0;
// }

// .slide-right-enter-active {
//   transition: all 8s ease;
// }
// .slide-right-leave-active {
//   transition: all 10s ease;
// }
// .slide-right-enter {
//   transform: translateX(100%);
//   opacity: 0;
// }
// .slide-right-leave-to {
//   transform: translateX(100%);
//   opacity: 0;
// }
//---
/*向左滑动*/
@keyframes slideInLeft {
  from {
    transform: translate3d(100%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
  to {
    transform: translate3d(0, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
}
@keyframes slideInRight {
  from {
    transform: translate3d(0%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
  to {
    transform: translate3d(-100%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
}
.slide-left-enter-active {
  position: fixed;
  top: 0;
  left: 0%;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  //opacity: 0;
  animation: slideInLeft 0.3s linear forwards;
}
.slide-left-leave-active {
  position: fixed;
  top: 0;
  left: 0%;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  //opacity: 0;
  animation: slideInRight 0.4s linear forwards;
}
/*向右滑动*/
@keyframes slideOutLeft {
  from {
    transform: translate3d(-100%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
  to {
    transform: translate3d(0%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
}
@keyframes slideOutRight {
  from {
    transform: translate3d(0%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
  to {
    transform: translate3d(100%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
}
.slide-right-enter-active {
  position: fixed;
  top: 0;
  left: 0%;
  width: 100vw;
  height: 100vh;
  //opacity: 0;
  animation: slideOutLeft 0.3s linear forwards;
}
.slide-right-leave-active {
  position: fixed;
  top: 0;
  left: 0%;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  //opacity: 0;
  animation: slideOutRight 0.3s linear forwards;
}
</style>



// WEBPACK FOOTER //
// src/App.vue